import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RollLoginState } from "../../../redux/reducers/getAuthReducer/rollLoginReducer";
import { RootState } from "../../../redux/reducers/root";
import AmpArrowTooltip from "../../common/AmpArrowTooltip/AmpArrowTooltip";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import RollAccessKeyImage from "../../common/RollAccessKey/RollAccessKeyImage";

import "../LoginContainer.css";
import "./NewUser.css";
import NewUserForm from "./NewUserForm";
import ReactGA from "react-ga4";
import addSuperScript from "../../../utils/superscript";

export default function NewUser(): JSX.Element {

    const { t } = useTranslation('login');

    const rollloginResult = useSelector((state: RootState) => state.authReducer.rollLogin as RollLoginState)

    if(rollloginResult.token && rollloginResult.success){
        window.localStorage.setItem("regtoken", rollloginResult.token as string);
        window.localStorage.setItem("addressCheck", rollloginResult.addr as string);
        window.localStorage.setItem("enotifAllowed", rollloginResult.enotif_allowed);
        window.localStorage.setItem("enotifDefault", rollloginResult.enotif_default);
        window.localStorage.setItem("regExp", rollloginResult.exp.toString());
        // Send a custom event
        ReactGA.event({
            category: "Login/Registration",
            action: "Registration Started",
            label: `${rollloginResult.token} Registration`, // optional
        });
        return (            
            <Navigate to={`/auth/registration/${rollloginResult.token}`} replace={true}/>
        )
    } else {
        return (
            <div className="login-container-row">
                <div className="login-container">
                    <div className="dark-blue-background">
                        {addSuperScript(t('new-user-prompt') as string)}
                    </div>
        
                    <AmpLoadingSpinner loading={rollloginResult.loading}>
                        <div className="login-container-content">
                            <p>
                                {t('new-user-prompt2') as string}
                            </p>
                            <AmpArrowTooltip title={t('new-user-tooltip') as string} items={[]} element={<RollAccessKeyImage />} />
                            <NewUserForm />
                        </div>
                    </AmpLoadingSpinner>
                </div>
                {/* <img alt="" className="new img-side" src="./images/ea_background-no-bg.png"/> */}
                {/* <PierTutorial /> */}
                
            </div>
        );
    }
    

}